module.exports = __webpack_public_path__ + "static/media/idcardfront.731358d4.png";